/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ReceivedScore, ReceivedScoreBaseModel } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class ReceivedScores<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags ReceivedScores
   * @name SaveScoreCreate
   * @request POST:/ReceivedScores/SaveScore
   */
  saveScoreCreate = (data: ReceivedScoreBaseModel[], params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/ReceivedScores/SaveScore`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ReceivedScores
   * @name BulkSaveBulkSaveScoresForPageantIdCreate
   * @request POST:/ReceivedScores/bulk-save/BulkSaveScoresForPageantId:{pageantId}
   */
  bulkSaveBulkSaveScoresForPageantIdCreate = (pageantId: number, data: ReceivedScoreBaseModel[], params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/ReceivedScores/bulk-save/BulkSaveScoresForPageantId:${pageantId}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ReceivedScores
   * @name GetByContestantGetScoresByContestantIdDetail
   * @request GET:/ReceivedScores/GetByContestant/GetScoresByContestantId:{contestantId}
   */
  getByContestantGetScoresByContestantIdDetail = (contestantId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/ReceivedScores/GetByContestant/GetScoresByContestantId:${contestantId}`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags ReceivedScores
   * @name GetTotalScoresForContestantByAocGetTotalScoresForContestantByAocDetail
   * @request GET:/ReceivedScores/GetTotalScoresForContestantByAOC/GetTotalScoresForContestantByAOC:{contestantId}
   */
  getTotalScoresForContestantByAocGetTotalScoresForContestantByAocDetail = (contestantId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/ReceivedScores/GetTotalScoresForContestantByAOC/GetTotalScoresForContestantByAOC:${contestantId}`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags ReceivedScores
   * @name GetTotalScoresWithDropsForContestantByAocGetTotalScoresWithDropsForContestantByAocDetail
   * @request GET:/ReceivedScores/GetTotalScoresWithDropsForContestantByAOC/GetTotalScoresWithDropsForContestantByAOC:{contestantId}
   */
  getTotalScoresWithDropsForContestantByAocGetTotalScoresWithDropsForContestantByAocDetail = (contestantId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/ReceivedScores/GetTotalScoresWithDropsForContestantByAOC/GetTotalScoresWithDropsForContestantByAOC:${contestantId}`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags ReceivedScores
   * @name GetTotalScoresWithDropsForContestantByAocAllGetTotalScoresWithDropsForContestantByAocAllDetail
   * @request GET:/ReceivedScores/GetTotalScoresWithDropsForContestantByAOCAll/GetTotalScoresWithDropsForContestantByAOCAll:{contestantId}
   */
  getTotalScoresWithDropsForContestantByAocAllGetTotalScoresWithDropsForContestantByAocAllDetail = (contestantId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/ReceivedScores/GetTotalScoresWithDropsForContestantByAOCAll/GetTotalScoresWithDropsForContestantByAOCAll:${contestantId}`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags ReceivedScores
   * @name GetFilteredTotalScoresWithDropsForContestantGetFilteredTotalScoresWithDropsForContestantDetail
   * @request GET:/ReceivedScores/GetFilteredTotalScoresWithDropsForContestant/GetFilteredTotalScoresWithDropsForContestant:{contestantId}
   */
  getFilteredTotalScoresWithDropsForContestantGetFilteredTotalScoresWithDropsForContestantDetail = (
    contestantId: number,
    query?: {
      aocScoringCategoryIds?: number[];
      aocIds?: number[];
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/ReceivedScores/GetFilteredTotalScoresWithDropsForContestant/GetFilteredTotalScoresWithDropsForContestant:${contestantId}`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags ReceivedScores
   * @name GetByJudgeGetByJudgeDetail
   * @request GET:/ReceivedScores/GetByJudge/GetByJudge:{judgeId}
   */
  getByJudgeGetByJudgeDetail = (judgeId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/ReceivedScores/GetByJudge/GetByJudge:${judgeId}`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags ReceivedScores
   * @name UpdateUpdateScoreUpdate
   * @request PUT:/ReceivedScores/Update/UpdateScore:{scoreId}
   */
  updateUpdateScoreUpdate = (scoreId: number, data: ReceivedScore, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/ReceivedScores/Update/UpdateScore:${scoreId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ReceivedScores
   * @name HardDeleteDelete
   * @request DELETE:/ReceivedScores/HardDelete/{scoreId}
   */
  hardDeleteDelete = (scoreId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/ReceivedScores/HardDelete/${scoreId}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags ReceivedScores
   * @name HardSecureDeleteDelete
   * @request DELETE:/ReceivedScores/HardSecureDelete/{scoreId}
   */
  hardSecureDeleteDelete = (scoreId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/ReceivedScores/HardSecureDelete/${scoreId}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags ReceivedScores
   * @name SoftDeleteDelete
   * @request DELETE:/ReceivedScores/SoftDelete/{scoreId}
   */
  softDeleteDelete = (scoreId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/ReceivedScores/SoftDelete/${scoreId}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags ReceivedScores
   * @name BulkCreateOrUpdateCreate
   * @request POST:/ReceivedScores/BulkCreateOrUpdate
   */
  bulkCreateOrUpdateCreate = (data: ReceivedScoreBaseModel[], params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/ReceivedScores/BulkCreateOrUpdate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ReceivedScores
   * @name GetAllScoresForPageant
   * @request GET:/ReceivedScores/GetAllScoresForPageant/GetAllScoresForPageant:{pageantId}
   */
  getAllScoresForPageant = (pageantId: number, params: RequestParams = {}) =>
    this.request<Record<string, ReceivedScoreBaseModel[]>, any>({
      path: `/ReceivedScores/GetAllScoresForPageant/GetAllScoresForPageant:${pageantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ReceivedScores
   * @name GetAllContestantDetailedScoreSheetsForPageant
   * @request GET:/ReceivedScores/GetAllContestantDetailedScoreSheetsForPageant/GetAllContestantDetailedScoreSheetsForPageant:{pageantId}
   */
  getAllContestantDetailedScoreSheetsForPageant = (pageantId: number, params: RequestParams = {}) =>
    this.request<Record<string, ReceivedScoreBaseModel[]>, any>({
      path: `/ReceivedScores/GetAllContestantDetailedScoreSheetsForPageant/GetAllContestantDetailedScoreSheetsForPageant:${pageantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ReceivedScores
   * @name GetTotalScoresWithDropsForContestantByAocNew
   * @request GET:/ReceivedScores/GetTotalScoresWithDropsForContestantByAOCNew/GetTotalScoresWithDropsForContestantByAOCNew:{contestantId}
   */
  getTotalScoresWithDropsForContestantByAocNew = (contestantId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/ReceivedScores/GetTotalScoresWithDropsForContestantByAOCNew/GetTotalScoresWithDropsForContestantByAOCNew:${contestantId}`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags ReceivedScores
   * @name BulkCreateOrUpdateScoresNew
   * @request POST:/ReceivedScores/BulkCreateOrUpdateScoresNew
   */
  bulkCreateOrUpdateScoresNew = (data: ReceivedScoreBaseModel[], params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/ReceivedScores/BulkCreateOrUpdateScoresNew`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
